import React, { useEffect, useState }  from 'react';

import { Body } from '@vds/typography';
import { Grid, Row, Col } from '@vds/grids';

import './PendingOrderContact.css';

const PendingOrderContact = (props) => {
    const [endInteraction, setEndInteraction] = useState(false);

    useEffect(() => {
        setEndInteraction(true);
    }, [])
    useEffect(() => {
        if(endInteraction && navigator?.userAgentData?.platform !== "macOS") {
            window.newrelic.interaction().end();
            setEndInteraction(false);
        }
    });
    return (
        <div className="pending-order-contact">
            <div className="container">
                <div className="row heading">
                    <div className="col-xs-12 heading-text">
                    <Grid >
                        <Row>
                            <Col colSizes={{ "mobile": 4, "tablet": 6, "desktop": 6 }}>
                                <Body size="medium" primitive="h4" bold>Your account already has an order pending. Please contact us to make additional changes.</Body>
                            </Col>
                        </Row>  
                    </Grid>          
                    </div>
                </div>
                <div className="row content">
                    <div className="content-text">
                        <Grid>
                            <Row>
                            <Col colSizes={{ "mobile":4, "tablet": 12, "desktop": 6 }} className="bottom-margin">
                                <Body primitive="p" size="small">
                                    Your account has an order pending. To make any changes to your account you will have to contact a business service representative by clicking one of the button(s) to the right.
                                </Body>
                            </Col>
                            <Col colSizes={{ "mobile": 4, "tablet": 12, "desktop": 6 }} className="col-md-6 col-lg-6">
                                <Body primitive="p" size="medium" color="red">Talk to Us for Your Best Deals</Body>
                                <br />
                                <Body primitive="p" size="small">To get the best available deal for your business, chat with a representative or request a callback now.</Body>
                                <br />
                                <Body primitive="h4" size="medium" color="red">Or Call us: 1-888-720-9944</Body>
                            </Col>
                            </Row>
                        </Grid>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default PendingOrderContact;